﻿  (function() {
    var sectionRoots = Array.prototype.slice.call(document.querySelectorAll('[data-prototype-pdp-section]'));
    var virtualStyle = {
      setProperty: function(name, value) {
        Array.prototype.forEach.call(sectionRoots, function(root) {
          root.style.setProperty(name, value);
        });
      }
    };
    var section = {
      style: virtualStyle,
      querySelector: function(selector) {
        var index;
        var found = null;

        for (index = 0; index < sectionRoots.length; index += 1) {
          found = sectionRoots[index].querySelector(selector);
          if (found) {
            return found;
          }
        }

        return null;
      },
      querySelectorAll: function(selector) {
        var matches = [];

        Array.prototype.forEach.call(sectionRoots, function(root) {
          matches = matches.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
        });

        return matches;
      },
      contains: function(node) {
        return sectionRoots.some(function(root) {
          return root.contains(node);
        });
      },
      setAttribute: function(name, value) {
        Array.prototype.forEach.call(sectionRoots, function(root) {
          root.setAttribute(name, value);
        });
      },
      addEventListener: function(type, listener, options) {
        Array.prototype.forEach.call(sectionRoots, function(root) {
          root.addEventListener(type, listener, options);
        });
      },
      removeEventListener: function(type, listener, options) {
        Array.prototype.forEach.call(sectionRoots, function(root) {
          root.removeEventListener(type, listener, options);
        });
      }
    };
    var pageHeader = document.querySelector('body.template-page-prototype-pdp .main-header-wrapper');
    var followupSection = section ? section.querySelector('.nectris-pdp__followup') : null;
    var revealSection = section ? section.querySelector('.nectris-pdp__reveal') : null;

    if (!sectionRoots.length) {
      return;
    }

    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var resizeTicking = false;
    var highlightTimer = null;

    var setStickyOffset = function() {
      var offset = 24;
      var header = document.querySelector('.sticky-header');

      if (header) {
        var headerStyles = window.getComputedStyle(header);

        if (headerStyles.position === 'fixed') {
          offset += header.offsetHeight;
        }
      }

      if (window.innerWidth <= 720) {
        offset = 20;
      }

      section.style.setProperty('--nectris-sticky-offset', offset + 'px');
    };

    var syncPageHeaderVisibility = function() {
      if (!pageHeader || !followupSection || !revealSection) {
        if (pageHeader) {
          pageHeader.classList.remove('is-nectris-hidden');
        }
        return;
      }

      var headerStyles = window.getComputedStyle(pageHeader);

      if (headerStyles.position !== 'fixed') {
        pageHeader.classList.remove('is-nectris-hidden');
        return;
      }

      var headerHeight = pageHeader.offsetHeight || 0;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      var followupRect = followupSection.getBoundingClientRect();
      var revealRect = revealSection.getBoundingClientRect();
      var followupBottom = scrollTop + followupRect.top + followupRect.height;
      var revealTop = scrollTop + revealRect.top;
      var headerTriggerY = scrollTop + headerHeight;
      var shouldHideHeader = headerTriggerY >= followupBottom && headerTriggerY < revealTop;

      pageHeader.classList.toggle('is-nectris-hidden', shouldHideHeader);
    };

    var requestStickyOffset = function() {
      if (resizeTicking) {
        return;
      }

      resizeTicking = true;

      window.requestAnimationFrame(function() {
        setStickyOffset();
        syncPageHeaderVisibility();
        resizeTicking = false;
      });
    };

    setStickyOffset();
    syncPageHeaderVisibility();
    window.addEventListener('resize', requestStickyOffset);
    window.addEventListener('scroll', requestStickyOffset, { passive: true });

    var heroMediaGrid = section.querySelector('.nectris-pdp__hero-media-grid');
    var heroMediaCards = heroMediaGrid ? heroMediaGrid.querySelectorAll('.nectris-pdp__media-card') : [];
    var heroPreloadOverlay = section.querySelector('[data-nectris-hero-preload-overlay]');
    var heroPreloadPercent = section.querySelector('[data-nectris-hero-preload-percent]');
    var heroPreloadCopyText = section.querySelector('[data-nectris-hero-preload-copy-text]');
    var heroPreloadBar = section.querySelector('[data-nectris-hero-preload-bar]');
    var followupFeature = section.querySelector('[data-nectris-followup-feature]');
    var proofSection = section.querySelector('.nectris-pdp__proof');
    var proofTrack = section.querySelector('[data-nectris-proof-track]');
    var proofCards = section.querySelectorAll('[data-nectris-proof-card]');
    var proofNavItems = section.querySelectorAll('[data-nectris-proof-nav]');
    var proofArrowButtons = section.querySelectorAll('[data-nectris-proof-arrow]');
    var editorialItems = section.querySelectorAll('[data-nectris-editorial-item]');
    var editorialTriggers = section.querySelectorAll('[data-nectris-editorial-trigger]');
    var editorialCarousels = section.querySelectorAll('[data-nectris-editorial-carousel]');
    var deferredImageSelector = '[data-nectris-deferred-image]';
    var managedVideoSelector = '[data-nectris-managed-video]';
    var managedAutoplayVideoSelector = '.nectris-pdp__hero-media-grid [data-nectris-managed-video], .nectris-pdp__editorial-carousel [data-nectris-managed-video]';
    var managedAutoplayObserver = null;
    var deferredImageObserver = null;
    var activeManagedVideoLoad = null;
    var activeManagedAutoplayStartupVideo = null;
    var managedVideoSyncQueued = false;
    var managedVideoInteractionActivated = false;
    var HERO_PRELOAD_MIN_DURATION_MS = 5000;
    var HERO_PRELOAD_REVEAL_FALLBACK_TIMEOUT_MS = 22000;
    var HERO_PRELOAD_BANDWIDTH_GATE_TIMEOUT_MS = 26000;
    var HERO_PRELOAD_DISPLAY_PROGRESS_FLOOR = 0.18;
    var HERO_PRELOAD_DISPLAY_PROGRESS_CEILING = 0.64;
    var heroPreloadAssets = [];
    var heroPreloadActive = false;
    var heroPreloadCompleted = false;
    var heroPrimaryBandwidthGateReleased = false;
    var heroPrimaryBandwidthGateTimer = null;
    var heroPreloadRafId = 0;
    var heroPreloadProgressValue = 0;
    var heroPreloadStartedAt = 0;
    var heroPreloadPhraseCycleTimer = null;
    var heroPreloadPhraseTypingTimer = null;
    var heroPreloadPhraseDelayIndex = 0;
    var heroPreloadPhrasePool = [];
    var heroPreloadPhraseCurrent = '';
    var heroPreloadPhraseCadence = [3000, 2000, 4000, 2000];
    var heroPreloadPhrases = [
      'Initializing impossible ant science...',
      'Calibrating nectar viscosity...',
      'Aligning colony vectors...',
      'Negotiating with the queen...',
      'Stabilizing exoskeletal shimmer...',
      'Finalizing impossible formula...',
      'Calibrating nectar lattice...',
      'Sterilizing queen-adjacent optics...',
      'Rehydrating tactical honeydew...',
      'Equalizing larval pressure...',
      'Tuning biomeletic viscosity...',
      'Synergizing ant-facing innovation...',
      'Streamlining subterranean outcomes...',
      'Optimizing worker throughput...',
      'Activating premium colony logic...',
      'Scaling impossible nutrition...',
      'Leveraging next-gen honeydew...',
      'Enhancing empire readiness...',
      'Shipping disruptive nectar soon...',
      'Polishing the queen firmware...',
      'De-wrinkling the ant aura...',
      'Negotiating with the larvae...',
      'Reversing sidewalk gravity...',
      'Whispering to the substrate...',
      'Inflating the nectar engine...',
      'Converting doubt into honeydew...',
      'Cross-referencing ant vibes...',
      'Sequencing caste anomalies...',
      'Suppressing ordinary biology...',
      'Reassigning worker destiny...',
      'Cloaking visible-spectrum doubt...',
      'Initiating species drift...',
      'Verifying improbable metamorphosis...',
      'Confirming queenward migration...',
      'Sealing the protocol...'
    ];
    var managedVideoConnectionProfile = 'pending';
    var managedVideoConnectionReady = false;
    var managedVideoPrimaryHeroVideo = null;
    var prototypePreloadState = window.__NECTRIS_PROTOTYPE_PRELOAD__ || {};
    var prototypePreloadWarmKey = typeof prototypePreloadState.warmKey === 'string' ? prototypePreloadState.warmKey : '';
    var prototypePreloadMode = prototypePreloadState && prototypePreloadState.mode ? String(prototypePreloadState.mode) : 'cold';

    var persistPrototypePreloadWarmMarker = function() {
      if (!prototypePreloadWarmKey) {
        return;
      }

      try {
        window.sessionStorage.setItem(prototypePreloadWarmKey, 'true');
      } catch (error) {}
    };

    var markPrototypePreloadSkipState = function(reason) {
      var resolvedReason = reason || 'skip';
      var docEl = document.documentElement;

      prototypePreloadMode = resolvedReason;

      if (!window.__NECTRIS_PROTOTYPE_PRELOAD__) {
        window.__NECTRIS_PROTOTYPE_PRELOAD__ = {};
      }

      window.__NECTRIS_PROTOTYPE_PRELOAD__.mode = resolvedReason;
      window.__NECTRIS_PROTOTYPE_PRELOAD__.warmKey = prototypePreloadWarmKey;

      if (docEl) {
        docEl.classList.add('nectris-prototype-preload-skip');
        docEl.setAttribute('data-nectris-prototype-preload-skip', resolvedReason);
      }
    };

    var getHeroPreloadSkipReason = function() {
      if (prototypePreloadMode && prototypePreloadMode !== 'cold') {
        return prototypePreloadMode;
      }

      if (heroPreloadOverlay) {
        var overlayReason = heroPreloadOverlay.getAttribute('data-nectris-preload-disabled') || '';

        if (overlayReason) {
          return overlayReason;
        }
      }

      if (window.Shopify && window.Shopify.designMode) {
        return 'editor';
      }

      return '';
    };

    var getAllManagedVideos = function() {
      return section.querySelectorAll(managedVideoSelector);
    };

    var getManagedAutoplayVideos = function() {
      return section.querySelectorAll(managedAutoplayVideoSelector);
    };

    var getManagedVideoRole = function(video) {
      if (!video) {
        return '';
      }

      return video.getAttribute('data-nectris-video-role') || '';
    };

    var getManagedVideoConnection = function() {
      return navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;
    };

    var getManagedVideoSourceProfile = function() {
      return managedVideoConnectionProfile === 'slow' ? 'low' : 'high';
    };

    var hasManagedVideoLowSource = function(video) {
      return !!video && video.getAttribute('data-nectris-video-has-low-source') === 'true';
    };

    var isManagedVideoExplicitMobileEnvironment = function() {
      var userAgent = navigator.userAgent || '';
      var userAgentData = navigator.userAgentData || null;

      if (userAgentData && typeof userAgentData.mobile === 'boolean') {
        return userAgentData.mobile;
      }

      return /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent);
    };

    var isManagedVideoLikelyDesktopEnvironment = function() {
      var userAgent = navigator.userAgent || '';

      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        return true;
      }

      if (navigator.userAgentData && navigator.userAgentData.mobile === false) {
        return true;
      }

      if (/Windows NT|Macintosh|X11|Linux x86_64|CrOS/i.test(userAgent) && !/Android|iPhone|iPad|iPod|Mobile/i.test(userAgent)) {
        return true;
      }

      return false;
    };

    var isLikelyManagedVideoMobileEnvironment = function() {
      if (isManagedVideoExplicitMobileEnvironment()) {
        return true;
      }

      if (isManagedVideoLikelyDesktopEnvironment()) {
        return false;
      }

      if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches && window.innerWidth <= 1024) {
        return true;
      }

      return (navigator.maxTouchPoints || 0) > 0 && window.innerWidth <= 1024;
    };

    var shouldShowPrimaryHeroPosterGuard = function(video) {
      return !!video &&
        getManagedVideoRole(video) === 'hero' &&
        video === getPrimaryHeroManagedVideo() &&
        (!video.dataset.nectrisVideoReady || video.readyState < 2);
    };

    var getPrimaryHeroManagedVideo = function() {
      if (!managedVideoPrimaryHeroVideo || !managedVideoPrimaryHeroVideo.isConnected) {
        managedVideoPrimaryHeroVideo = section.querySelector('.nectris-pdp__hero-media-grid [data-nectris-managed-video][data-nectris-video-role="hero"]');
      }

      return managedVideoPrimaryHeroVideo;
    };

    var shouldDeferHeroVideoUntilInteraction = function(video) {
      if (!video || getManagedVideoRole(video) !== 'hero') {
        return false;
      }

      if (video === getPrimaryHeroManagedVideo()) {
        return false;
      }

      if (!heroPrimaryBandwidthGateReleased) {
        return true;
      }

      if (managedVideoInteractionActivated) {
        return false;
      }

      return isLikelyManagedVideoMobileEnvironment();
    };

    var shouldFallbackManagedVideoToPoster = function(video) {
      return !!video &&
        managedVideoConnectionReady &&
        managedVideoConnectionProfile === 'slow' &&
        !hasManagedVideoLowSource(video);
    };

    var shouldForcePrimaryHeroPreload = function(video) {
      return !!video &&
        heroPreloadActive &&
        !heroPreloadCompleted &&
        getManagedVideoRole(video) === 'hero' &&
        video === getPrimaryHeroManagedVideo() &&
        !shouldFallbackManagedVideoToPoster(video);
    };

    var shouldBlockManagedVideoUntilHeroBandwidthGateRelease = function(video) {
      if (!video || heroPrimaryBandwidthGateReleased) {
        return false;
      }

      var role = getManagedVideoRole(video);
      return role === 'proof' || role === 'editorial';
    };

    var shouldBlockProofVideoBeforeHeroPhaseCompletes = function() {
      return !heroPrimaryBandwidthGateReleased;
    };

    var resolveManagedVideoConnectionProfile = function(profile) {
      if (managedVideoConnectionReady) {
        return;
      }

      managedVideoConnectionProfile = profile === 'slow' ? 'slow' : 'high';
      managedVideoConnectionReady = true;
      section.setAttribute('data-nectris-video-profile', managedVideoConnectionProfile);
      Array.prototype.forEach.call(getAllManagedVideos(), function(video) {
        ensureManagedVideoPoster(video);
        clearManagedVideoReadyState(video);
        video.dataset.nectrisVideoProfile = shouldFallbackManagedVideoToPoster(video) ? 'poster' : getManagedVideoSourceProfile();
      });
      heroPreloadAssets = collectHeroPreloadAssets();
      updateHeroPreloadProgress();
      queueManagedAutoplaySync();
    };

    var detectManagedVideoConnectionProfile = function() {
      if (managedVideoConnectionReady) {
        return;
      }

      var connection = getManagedVideoConnection();
      var effectiveType = connection && connection.effectiveType ? String(connection.effectiveType).toLowerCase() : '';
      var shouldUseLowProfile = false;

      if (connection && connection.saveData) {
        shouldUseLowProfile = true;
      }

      if (!shouldUseLowProfile && (effectiveType === 'slow-2g' || effectiveType === '2g' || effectiveType === '3g')) {
        shouldUseLowProfile = true;
      }

      if (!shouldUseLowProfile && isLikelyManagedVideoMobileEnvironment()) {
        shouldUseLowProfile = true;
      }

      resolveManagedVideoConnectionProfile(shouldUseLowProfile ? 'slow' : 'high');
    };

    var isManagedPassiveAutoplayVideo = function(video) {
      var role = getManagedVideoRole(video);
      return role === 'hero' || role === 'editorial';
    };

    var setManagedVideoPreloadMode = function(video, mode) {
      if (!video) {
        return;
      }

      var preloadMode = mode || 'none';
      video.preload = preloadMode;
      video.setAttribute('preload', preloadMode);
    };

    var normalizeManagedAutoplayVideo = function(video) {
      if (!video) {
        return;
      }

      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.removeAttribute('autoplay');
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    };

    var getManagedAutoplayVisibilityTarget = function(video) {
      return video.closest('[data-nectris-editorial-slide]') || video.closest('.nectris-pdp__media-card') || video;
    };

    var isManagedAutoplayVideoVisible = function(video) {
      if (!video || document.hidden || !video.isConnected) {
        return false;
      }

      if (video.closest('[hidden]')) {
        return false;
      }

      var editorialSlide = video.closest('[data-nectris-editorial-slide]');

      if (editorialSlide && !editorialSlide.classList.contains('is-active')) {
        return false;
      }

      var visibilityTarget = getManagedAutoplayVisibilityTarget(video);
      var visibilityStyles = window.getComputedStyle(visibilityTarget);

      if (visibilityStyles.display === 'none' || visibilityStyles.visibility === 'hidden' || parseFloat(visibilityStyles.opacity || '1') < 0.01) {
        return false;
      }

      var rect = visibilityTarget.getBoundingClientRect();

      if (rect.width < 2 || rect.height < 2) {
        return false;
      }

      return rect.bottom > 0 &&
        rect.right > 0 &&
        rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth);
    };

    var shouldSerialGateManagedAutoplayVideo = function(video) {
      if (!video || !isManagedPassiveAutoplayVideo(video) || !isManagedAutoplayVideoVisible(video)) {
        return false;
      }

      if (heroPreloadCompleted || !heroPreloadActive) {
        return false;
      }

      return getManagedVideoRole(video) === 'hero' && managedVideoConnectionReady;
    };

    var clearManagedAutoplayStartupTimer = function(video) {
      if (!video || !video._nectrisAutoplayStartupTimer) {
        return;
      }

      window.clearTimeout(video._nectrisAutoplayStartupTimer);
      video._nectrisAutoplayStartupTimer = null;
    };

    var getManagedVideoBufferedEnd = function(video) {
      if (!video || !video.buffered || !video.buffered.length) {
        return 0;
      }

      try {
        return video.buffered.end(video.buffered.length - 1);
      } catch (error) {
        return 0;
      }
    };

    var isManagedVideoFullyBuffered = function(video) {
      if (!video || video.readyState < 2) {
        return false;
      }

      var duration = video.duration;

      if (!isFinite(duration) || duration <= 0) {
        return video.readyState >= 4;
      }

      var bufferedEnd = getManagedVideoBufferedEnd(video);
      var tolerance = Math.min(0.75, Math.max(0.35, duration * 0.01));

      return bufferedEnd >= Math.max(0, duration - tolerance);
    };

    var releaseManagedAutoplayStartupVideo = function(video) {
      if (!video) {
        return;
      }

      clearManagedAutoplayStartupTimer(video);
      delete video.dataset.nectrisAutoplayStartupState;

      if (activeManagedAutoplayStartupVideo === video) {
        activeManagedAutoplayStartupVideo = null;

        if (typeof queueManagedAutoplaySync === 'function') {
          queueManagedAutoplaySync();
        }
      }
    };

    var scheduleManagedAutoplayStartupRelease = function(video) {
      if (!shouldSerialGateManagedAutoplayVideo(video)) {
        releaseManagedAutoplayStartupVideo(video);
        return;
      }

      clearManagedAutoplayStartupTimer(video);

      if (getManagedVideoRole(video) === 'hero') {
        video.dataset.nectrisAutoplayStartupState = 'buffering';

        if (isManagedVideoFullyBuffered(video)) {
          releaseManagedAutoplayStartupVideo(video);
        }

        return;
      }

      video.dataset.nectrisAutoplayStartupState = 'starting';
      video._nectrisAutoplayStartupTimer = window.setTimeout(function() {
        video._nectrisAutoplayStartupTimer = null;
        releaseManagedAutoplayStartupVideo(video);
      }, 900);
    };

    var isElementWithinLoadRange = function(element, aheadPx, behindPx) {
      if (!element) {
        return false;
      }

      var rect = element.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

      return rect.bottom > -(behindPx || 0) && rect.top < viewportHeight + (aheadPx || 0);
    };

    var canHydrateDeferredImage = function(image) {
      if (!image || image.getAttribute('data-nectris-image-loaded') === 'true') {
        return false;
      }

      var deferUntil = image.getAttribute('data-nectris-defer-until') || '';
      var isActiveHeroPreloadAsset = heroPreloadAssets.indexOf(image) !== -1;

      if (deferUntil === 'hero-preload' && !heroPreloadCompleted && !isActiveHeroPreloadAsset) {
        return false;
      }

      return true;
    };

    var hydrateDeferredImage = function(image) {
      if (!canHydrateDeferredImage(image)) {
        return;
      }

      var src = image.getAttribute('data-src');
      var srcset = image.getAttribute('data-srcset');

      if (deferredImageObserver) {
        deferredImageObserver.unobserve(image);
      }

      image.loading = 'eager';

      if (src) {
        image.setAttribute('src', src);
      }

      if (srcset) {
        image.setAttribute('srcset', srcset);
      }

      image.setAttribute('data-nectris-image-loaded', 'true');
      image.removeAttribute('data-nectris-deferred-image');
    };

    var observeDeferredImages = function() {
      var deferredImages = section.querySelectorAll(deferredImageSelector);

      if (!deferredImages.length) {
        return;
      }

      if (!('IntersectionObserver' in window)) {
        syncDeferredImages();
        return;
      }

      if (!deferredImageObserver) {
        deferredImageObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (!entry.isIntersecting && entry.intersectionRatio <= 0) {
              return;
            }

            hydrateDeferredImage(entry.target);
          });
        }, {
          root: null,
          rootMargin: '65% 0px 140px 0px',
          threshold: 0.01
        });
      }

      Array.prototype.forEach.call(deferredImages, function(image) {
        if (image.getAttribute('data-nectris-image-loaded') === 'true') {
          return;
        }

        deferredImageObserver.observe(image);
      });
    };

    var syncDeferredImages = function() {
      Array.prototype.forEach.call(section.querySelectorAll(deferredImageSelector), function(image) {
        if (!canHydrateDeferredImage(image)) {
          return;
        }

        if (isElementWithinLoadRange(image, window.innerHeight * 0.65, 140)) {
          hydrateDeferredImage(image);
        }
      });
    };

    var getManagedVideoPriorityBoost = function(video) {
      if (!video || !video._nectrisPriorityBoostUntil || video._nectrisPriorityBoostUntil < Date.now()) {
        return 0;
      }

      return video._nectrisPriorityBoost || 0;
    };

    var boostManagedVideoPriority = function(video, amount, durationMs) {
      if (!video) {
        return;
      }

      video._nectrisPriorityBoost = amount || 0;
      video._nectrisPriorityBoostUntil = Date.now() + (durationMs || 1800);
    };

    var hasManagedVideoSources = function(video) {
      return !!video && video.dataset.nectrisVideoSourcesAttached === 'true';
    };

    var syncManagedVideoSourceProfile = function(video) {
      if (!video) {
        return false;
      }

      var previousProfile = video.dataset.nectrisVideoProfile || '';
      var hadSourcesAttached = hasManagedVideoSources(video);
      var desiredProfile = shouldFallbackManagedVideoToPoster(video) ? 'poster' : getManagedVideoSourceProfile();
      var profileChanged = previousProfile !== desiredProfile;
      var sourceChanged = false;

      ensureManagedVideoPoster(video);
      setManagedVideoPosterFallbackVisibility(video, false);

      if (desiredProfile === 'poster') {
        if (hadSourcesAttached) {
          Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function(source) {
            if (source.getAttribute('src')) {
              source.removeAttribute('src');
              sourceChanged = true;
            }
          });

          video.removeAttribute('src');
          video.dataset.nectrisVideoSourcesAttached = 'false';
        }

        if (profileChanged || sourceChanged) {
          if (!video.paused || !video.ended) {
            try {
              video.pause();
            } catch (error) {}
          }

          if (activeManagedVideoLoad === video) {
            activeManagedVideoLoad = null;
          }

          releaseManagedAutoplayStartupVideo(video);
          clearManagedVideoReadyState(video);

          try {
            video.load();
          } catch (error) {}
        }

        video.dataset.nectrisVideoState = 'poster';
        video.dataset.nectrisVideoProfile = 'poster';
        setManagedVideoPosterFallbackVisibility(video, true);
        return profileChanged || sourceChanged;
      }

      Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function(source) {
        var profileSource = source.getAttribute(desiredProfile === 'low' ? 'data-src-low' : 'data-src-high') ||
          source.getAttribute('data-src-high') ||
          source.getAttribute('data-src-low') ||
          source.getAttribute('data-src');

        if (profileSource && source.getAttribute('src') !== profileSource) {
          source.setAttribute('src', profileSource);
          sourceChanged = true;
        }
      });

      video.dataset.nectrisVideoSourcesAttached = 'true';
      video.dataset.nectrisVideoProfile = desiredProfile;

      if (!hadSourcesAttached || profileChanged || sourceChanged) {
        if (hadSourcesAttached) {
          try {
            video.pause();
          } catch (error) {}
        }

        if (activeManagedVideoLoad === video) {
          activeManagedVideoLoad = null;
        }

        releaseManagedAutoplayStartupVideo(video);
        clearManagedVideoReadyState(video);
      }

      return !hadSourcesAttached || profileChanged || sourceChanged;
    };

    var clearManagedVideoReadyState = function(video) {
      if (!video) {
        return;
      }

      ensureManagedVideoPoster(video);
      setManagedVideoPosterFallbackVisibility(video, shouldFallbackManagedVideoToPoster(video));
      delete video.dataset.nectrisVideoReady;

      if (shouldFallbackManagedVideoToPoster(video)) {
        video.dataset.nectrisVideoState = 'poster';
      } else if (video.dataset.nectrisVideoState !== 'error') {
        video.dataset.nectrisVideoState = hasManagedVideoSources(video) ? 'idle' : 'detached';
      }

      if (typeof refreshProofCardVideoUi === 'function') {
        refreshProofCardVideoUi(video);
      }
    };

    var markManagedVideoReady = function(video) {
      if (!video) {
        return;
      }

      setManagedVideoPosterFallbackVisibility(video, false);
      video.dataset.nectrisVideoReady = 'true';
      video.dataset.nectrisVideoState = 'ready';

      if (activeManagedVideoLoad === video) {
        activeManagedVideoLoad = null;
      }

      if (typeof refreshProofCardVideoUi === 'function') {
        refreshProofCardVideoUi(video);
      }
    };

    var ensureManagedVideoPoster = function(video) {
      if (!video) {
        return;
      }

      var posterUrl = video.getAttribute('data-nectris-video-poster-url');

      if (!posterUrl || video.getAttribute('poster') === posterUrl) {
        return;
      }

      video.setAttribute('poster', posterUrl);
    };

    var ensureManagedVideoPosterImage = function(video) {
      if (!video || getManagedVideoRole(video) === 'proof') {
        return null;
      }

      var posterUrl = video.getAttribute('data-nectris-video-poster-url');

      if (!posterUrl || !video.parentNode) {
        return null;
      }

      if (video._nectrisPosterImage && video._nectrisPosterImage.isConnected) {
        return video._nectrisPosterImage;
      }

      var posterImage = document.createElement('img');
      posterImage.hidden = true;
      posterImage.decoding = 'async';
      posterImage.loading = 'eager';
      posterImage.alt = video.getAttribute('aria-label') || '';
      posterImage.className = 'nectris-pdp__managed-video-poster-fallback';
      posterImage.setAttribute('data-nectris-managed-video-poster-image', 'true');
      posterImage.setAttribute('data-nectris-video-poster-url', posterUrl);
      video.parentNode.insertBefore(posterImage, video);
      video._nectrisPosterImage = posterImage;
      return posterImage;
    };

    var isManagedVideoPosterReady = function(video) {
      if (!video) {
        return false;
      }

      var posterUrl = video.getAttribute('data-nectris-video-poster-url') || video.getAttribute('poster');
      var posterImage = ensureManagedVideoPosterImage(video);

      if (posterImage && posterUrl && posterImage.getAttribute('src') !== posterUrl) {
        posterImage.setAttribute('src', posterUrl);
      }

      return !!posterUrl && !!posterImage && posterImage.complete && posterImage.naturalWidth > 0;
    };

    var setManagedVideoPosterFallbackVisibility = function(video, shouldShow) {
      if (!video) {
        return;
      }

      var posterUrl = video.getAttribute('data-nectris-video-poster-url');
      var posterImage = ensureManagedVideoPosterImage(video);
      var shouldRevealPoster = !!shouldShow || shouldShowPrimaryHeroPosterGuard(video);

      video.classList.toggle('is-nectris-poster-fallback', shouldRevealPoster);

      if (!posterImage || !posterUrl) {
        return;
      }

      if (shouldRevealPoster) {
        if (posterImage.getAttribute('src') !== posterUrl) {
          posterImage.setAttribute('src', posterUrl);
        }

        posterImage.hidden = false;
        return;
      }

      posterImage.hidden = true;
    };

    var assignManagedVideoSources = function(video) {
      if (!video) {
        return;
      }

      syncManagedVideoSourceProfile(video);
    };

    var abortManagedVideoLoad = function(video) {
      if (!video || !hasManagedVideoSources(video) || (!video.paused && !video.ended)) {
        return;
      }

      Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function(source) {
        source.removeAttribute('src');
      });

      video.removeAttribute('src');
      video.dataset.nectrisVideoSourcesAttached = 'false';

      if (activeManagedVideoLoad === video) {
        activeManagedVideoLoad = null;
      }

      clearManagedVideoReadyState(video);
      releaseManagedAutoplayStartupVideo(video);

      try {
        video.load();
      } catch (error) {}
    };

    var isManagedVideoReady = function(video) {
      if (shouldFallbackManagedVideoToPoster(video)) {
        return true;
      }

      return !!video && (video.dataset.nectrisVideoReady === 'true' || video.readyState >= 2);
    };

    var startManagedVideoLoad = function(video, priority) {
      if (!managedVideoConnectionReady || !video || isManagedVideoReady(video) || shouldFallbackManagedVideoToPoster(video)) {
        return;
      }

      if (shouldSerialGateManagedAutoplayVideo(video)) {
        if (activeManagedAutoplayStartupVideo && activeManagedAutoplayStartupVideo !== video) {
          return;
        }

        activeManagedAutoplayStartupVideo = video;
        video.dataset.nectrisAutoplayStartupState = 'queued';
      }

      normalizeManagedAutoplayVideo(video);
      setManagedVideoPreloadMode(video, getManagedVideoLoadMode(video, typeof priority === 'number' ? priority : getManagedVideoPriority(video)));
      assignManagedVideoSources(video);
      activeManagedVideoLoad = video;
      video.dataset.nectrisVideoState = 'loading';

      try {
        video.load();
      } catch (error) {
        activeManagedVideoLoad = null;
      }
    };

    var pauseManagedAutoplayVideo = function(video) {
      if (!video) {
        return;
      }

      if (shouldForcePrimaryHeroPreload(video)) {
        setManagedVideoPreloadMode(video, 'auto');

        try {
          video.pause();
        } catch (error) {}

        return;
      }

      if (shouldFallbackManagedVideoToPoster(video)) {
        clearManagedVideoReadyState(video);
        releaseManagedAutoplayStartupVideo(video);

        try {
          video.pause();
        } catch (error) {}

        return;
      }

      if (getManagedVideoRole(video) !== 'proof') {
        setManagedVideoPreloadMode(video, 'metadata');
      }

      try {
        video.pause();
      } catch (error) {}

      if (!isManagedAutoplayVideoVisible(video)) {
        releaseManagedAutoplayStartupVideo(video);
      }
    };

    var playManagedAutoplayVideo = function(video) {
      if (!video) {
        return;
      }

      if (shouldBlockManagedVideoUntilHeroBandwidthGateRelease(video)) {
        setManagedVideoPreloadMode(video, 'none');

        try {
          video.pause();
        } catch (error) {}

        return;
      }

      if (shouldFallbackManagedVideoToPoster(video)) {
        pauseManagedAutoplayVideo(video);
        return;
      }

      normalizeManagedAutoplayVideo(video);
      setManagedVideoPreloadMode(video, 'auto');

      if (!isManagedVideoReady(video)) {
        requestManagedVideoPriorityLoad(video, 480, 2200, false);
        return;
      }

      if (managedVideoConnectionProfile === 'slow' &&
        getManagedVideoRole(video) === 'hero' &&
        video === getPrimaryHeroManagedVideo() &&
        !managedVideoInteractionActivated &&
        !isManagedVideoFullyBuffered(video)) {
        requestManagedVideoPriorityLoad(video, 620, 2400, false);
        return;
      }

      if (!video.paused && !video.ended && video.readyState >= 2) {
        scheduleManagedAutoplayStartupRelease(video);
        return;
      }

      var playAttempt = video.play();

      if (playAttempt && typeof playAttempt.then === 'function') {
        playAttempt.then(function() {
          scheduleManagedAutoplayStartupRelease(video);
        }).catch(function() {
          releaseManagedAutoplayStartupVideo(video);
          window.setTimeout(queueManagedAutoplaySync, 160);
        });
      } else {
        scheduleManagedAutoplayStartupRelease(video);
      }
    };

    var getManagedVideoPriority = function(video) {
      if (!video || !video.isConnected) {
        return 0;
      }

      var boost = getManagedVideoPriorityBoost(video);
      var role = getManagedVideoRole(video);

      if (shouldFallbackManagedVideoToPoster(video)) {
        return 0;
      }

      if (role === 'proof') {
        var proofCard = video.closest('[data-nectris-proof-card]');
        var shouldPlayProof = video.dataset.nectrisProofShouldPlay === 'true';
        var proofCardIsActive = proofCard && proofCard.classList.contains('is-active');
        var proofSectionIsNear = proofSection && isElementWithinLoadRange(proofSection, window.innerHeight * 0.75, window.innerHeight * 0.25);

        if (shouldBlockManagedVideoUntilHeroBandwidthGateRelease(video)) {
          return 0;
        }

        if (!proofSectionIsNear) {
          return boost;
        }

        if (proofCardIsActive && shouldPlayProof) {
          return 1000 + boost;
        }

        if (proofCardIsActive) {
          return 720 + boost;
        }

        return boost;
      }

      if (role === 'editorial') {
        var slide = video.closest('[data-nectris-editorial-slide]');
        var panel = video.closest('[data-nectris-editorial-panel]');
        var item = video.closest('[data-nectris-editorial-item]');
        var slideIsActive = slide && slide.classList.contains('is-active');
        var panelIsVisible = panel && !panel.hidden;

        if (shouldBlockManagedVideoUntilHeroBandwidthGateRelease(video)) {
          return 0;
        }

        if (!slideIsActive || !panelIsVisible || !item) {
          return boost;
        }

        if (isManagedAutoplayVideoVisible(video)) {
          return 640 + boost;
        }

        if (isElementWithinLoadRange(item, window.innerHeight * 0.75, window.innerHeight * 0.25)) {
          return 420 + boost;
        }

        return boost;
      }

      if (role === 'hero') {
        var heroCard = video.closest('.nectris-pdp__media-card');

        if (!heroCard) {
          return boost;
        }

        if (shouldDeferHeroVideoUntilInteraction(video)) {
          return boost;
        }

        if (video === getPrimaryHeroManagedVideo() && !heroPrimaryBandwidthGateReleased) {
          return 920 + boost;
        }

        if (isManagedAutoplayVideoVisible(video)) {
          var rect = heroCard.getBoundingClientRect();
          return 540 - Math.min(Math.abs(rect.top), 240) + boost;
        }

        if (isElementWithinLoadRange(heroCard, window.innerHeight * 0.35, 80)) {
          return 250 + boost;
        }
      }

      return boost;
    };

    var getManagedVideoLoadMode = function(video, priority) {
      if (!video) {
        return 'none';
      }

      var role = getManagedVideoRole(video);

      if (role === 'proof') {
        if (shouldBlockManagedVideoUntilHeroBandwidthGateRelease(video)) {
          return 'none';
        }

        var proofCard = video.closest('[data-nectris-proof-card]');
        var proofSectionIsNear = proofSection && isElementWithinLoadRange(proofSection, window.innerHeight * 0.75, window.innerHeight * 0.25);

        if (!proofCard || !proofCard.classList.contains('is-active') || !proofSectionIsNear) {
          return 'none';
        }

        if (video.dataset.nectrisProofShouldPlay === 'true') {
          return 'auto';
        }

        return priority >= 600 ? 'metadata' : 'none';
      }

      if (role === 'editorial') {
        if (shouldBlockManagedVideoUntilHeroBandwidthGateRelease(video)) {
          return 'none';
        }

        return isManagedAutoplayVideoVisible(video) ? 'auto' : (priority >= 420 ? 'metadata' : 'none');
      }

      if (role === 'hero') {
        if (shouldForcePrimaryHeroPreload(video)) {
          return 'auto';
        }

        return isManagedAutoplayVideoVisible(video) ? 'auto' : (priority >= 250 ? 'metadata' : 'none');
      }

      return priority > 0 ? 'metadata' : 'none';
    };

    var requestManagedVideoPriorityLoad = function(video, boostAmount, durationMs, allowPreempt) {
      if (!managedVideoConnectionReady || !video || shouldFallbackManagedVideoToPoster(video)) {
        if (video) {
          clearManagedVideoReadyState(video);
        }
        return;
      }

      if (boostAmount) {
        boostManagedVideoPriority(video, boostAmount, durationMs);
      }

      var priority = getManagedVideoPriority(video);

      if (priority <= 0) {
        return;
      }

      if (allowPreempt && shouldPreemptManagedVideoLoad(video, priority)) {
        abortManagedVideoLoad(activeManagedVideoLoad);
      }

      var desiredLoadMode = getManagedVideoLoadMode(video, priority);

      if (activeManagedVideoLoad === video) {
        var previousLoadMode = video.getAttribute('preload') || 'none';
        setManagedVideoPreloadMode(video, desiredLoadMode);

        if (desiredLoadMode === 'auto' && !isManagedVideoReady(video) && (previousLoadMode !== 'auto' || video.dataset.nectrisVideoState === 'metadata')) {
          video.dataset.nectrisVideoState = 'loading';

          try {
            video.load();
          } catch (error) {}
        }

        return;
      }

      if (!activeManagedVideoLoad) {
        startManagedVideoLoad(video, priority);
      }
    };

    var shouldPreemptManagedVideoLoad = function(nextVideo, nextPriority) {
      if (!activeManagedVideoLoad || activeManagedVideoLoad === nextVideo || isManagedVideoReady(activeManagedVideoLoad)) {
        return false;
      }

      var activePriority = getManagedVideoPriority(activeManagedVideoLoad);
      var activeRole = getManagedVideoRole(activeManagedVideoLoad);
      var activeShouldStayLoaded = (activeRole === 'proof' && activeManagedVideoLoad.dataset.nectrisProofShouldPlay === 'true') ||
        (activeRole !== 'proof' && isManagedAutoplayVideoVisible(activeManagedVideoLoad));

      if (activeShouldStayLoaded && activePriority >= nextPriority) {
        return false;
      }

      return nextPriority >= activePriority + 160;
    };

    var shouldKeepManagedVideoAttached = function(video) {
      if (!video || !hasManagedVideoSources(video)) {
        return false;
      }

      if (activeManagedVideoLoad === video) {
        return true;
      }

      var role = getManagedVideoRole(video);

      if (role === 'proof') {
        var proofCard = video.closest('[data-nectris-proof-card]');
        return (proofCard && proofCard.classList.contains('is-active')) || video.dataset.nectrisProofShouldPlay === 'true';
      }

      if (role === 'editorial') {
        var slide = video.closest('[data-nectris-editorial-slide]');
        var panel = video.closest('[data-nectris-editorial-panel]');
        var item = video.closest('[data-nectris-editorial-item]');
        var slideIsActive = slide && slide.classList.contains('is-active');
        var panelIsVisible = panel && !panel.hidden;

        if (!slideIsActive || !panelIsVisible || !item) {
          return false;
        }

        return isManagedAutoplayVideoVisible(video) || isElementWithinLoadRange(item, window.innerHeight * 0.6, window.innerHeight * 0.2);
      }

      if (role === 'hero') {
        var heroCard = video.closest('.nectris-pdp__media-card');

        if (shouldForcePrimaryHeroPreload(video)) {
          return true;
        }

        if (shouldDeferHeroVideoUntilInteraction(video)) {
          return false;
        }

        return isManagedAutoplayVideoVisible(video) || (heroCard && isElementWithinLoadRange(heroCard, window.innerHeight * 0.2, 60));
      }

      return false;
    };

    var pruneManagedVideoAttachments = function() {
      Array.prototype.forEach.call(getAllManagedVideos(), function(video) {
        if (!hasManagedVideoSources(video) || shouldKeepManagedVideoAttached(video)) {
          return;
        }

        if (!video.paused && !video.ended) {
          pauseManagedAutoplayVideo(video);
        }

        abortManagedVideoLoad(video);
      });
    };

    var syncManagedVideoBroker = function() {
      if (activeManagedAutoplayStartupVideo && !shouldSerialGateManagedAutoplayVideo(activeManagedAutoplayStartupVideo)) {
        releaseManagedAutoplayStartupVideo(activeManagedAutoplayStartupVideo);
      }

      var candidates = [];

      Array.prototype.forEach.call(getAllManagedVideos(), function(video, index) {
        normalizeManagedAutoplayVideo(video);

        if (isManagedVideoReady(video)) {
          return;
        }

        if (video.dataset.nectrisVideoState === 'error') {
          return;
        }

        var priority = getManagedVideoPriority(video);

        if (priority <= 0) {
          return;
        }

        candidates.push({
          video: video,
          priority: priority,
          index: index
        });
      });

      candidates.sort(function(a, b) {
        if (b.priority !== a.priority) {
          return b.priority - a.priority;
        }

        return a.index - b.index;
      });

      if (!candidates.length) {
        return;
      }

      var nextCandidate = candidates[0];

      if (!activeManagedVideoLoad) {
        startManagedVideoLoad(nextCandidate.video, nextCandidate.priority);
      }
    };

    var syncManagedAutoplayVideos = function() {
      Array.prototype.forEach.call(getManagedAutoplayVideos(), function(video) {
        if (shouldDeferHeroVideoUntilInteraction(video)) {
          pauseManagedAutoplayVideo(video);
          return;
        }

        if (isManagedAutoplayVideoVisible(video)) {
          playManagedAutoplayVideo(video);
        } else {
          pauseManagedAutoplayVideo(video);
        }
      });
    };

    var queueManagedAutoplaySync = function() {
      if (managedVideoSyncQueued) {
        return;
      }

      managedVideoSyncQueued = true;

      window.requestAnimationFrame(function() {
        managedVideoSyncQueued = false;

        if (!managedVideoConnectionReady) {
          return;
        }

        syncManagedVideoBroker();
        syncManagedAutoplayVideos();
        syncDeferredImages();
        pruneManagedVideoAttachments();

        if (typeof syncAllProofCardVideos === 'function') {
          syncAllProofCardVideos();
        }
      });
    };

    var isHeroPreloadCardVisible = function(card) {
      if (!card) {
        return false;
      }

      var rect = card.getBoundingClientRect();
      return rect.width > 2 &&
        rect.height > 2 &&
        rect.bottom > 0 &&
        rect.right > 0 &&
        rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth);
    };

    var collectHeroPreloadAssets = function() {
      var primaryHeroVideo = getPrimaryHeroManagedVideo();
      if (primaryHeroVideo && !shouldDeferHeroVideoUntilInteraction(primaryHeroVideo)) {
        return [primaryHeroVideo];
      }

      Array.prototype.some.call(heroMediaCards, function(card) {
        if (!isHeroPreloadCardVisible(card)) {
          return false;
        }

        var fallbackAsset = card.querySelector('[data-nectris-managed-video][data-nectris-video-role="hero"], img.nectris-pdp__media-card-image');

        if (fallbackAsset) {
          primaryHeroVideo = fallbackAsset;
          return true;
        }

        return false;
      });

      if (!primaryHeroVideo && heroMediaGrid) {
        primaryHeroVideo = heroMediaGrid.querySelector('[data-nectris-managed-video][data-nectris-video-role="hero"], img.nectris-pdp__media-card-image');
      }

      return primaryHeroVideo ? [primaryHeroVideo] : [];
    };

    var shuffleHeroPreloadPhrases = function(phrases) {
      var pool = phrases.slice();

      for (var index = pool.length - 1; index > 0; index -= 1) {
        var swapIndex = Math.floor(Math.random() * (index + 1));
        var currentPhrase = pool[index];
        pool[index] = pool[swapIndex];
        pool[swapIndex] = currentPhrase;
      }

      return pool;
    };

    var getNextHeroPreloadPhrase = function() {
      if (!heroPreloadPhrasePool.length) {
        heroPreloadPhrasePool = shuffleHeroPreloadPhrases(heroPreloadPhrases);

        if (heroPreloadPhraseCurrent && heroPreloadPhrasePool.length > 1 && heroPreloadPhrasePool[0] === heroPreloadPhraseCurrent) {
          heroPreloadPhrasePool.push(heroPreloadPhrasePool.shift());
        }
      }

      heroPreloadPhraseCurrent = heroPreloadPhrasePool.shift() || 'Finalizing impossible formula...';
      return heroPreloadPhraseCurrent;
    };

    var clearHeroPreloadPhraseTimers = function() {
      if (heroPreloadPhraseCycleTimer) {
        window.clearTimeout(heroPreloadPhraseCycleTimer);
        heroPreloadPhraseCycleTimer = null;
      }

      if (heroPreloadPhraseTypingTimer) {
        window.clearTimeout(heroPreloadPhraseTypingTimer);
        heroPreloadPhraseTypingTimer = null;
      }
    };

    var typeHeroPreloadPhrase = function(phrase) {
      if (!heroPreloadCopyText) {
        return;
      }

      clearHeroPreloadPhraseTimers();
      heroPreloadCopyText.textContent = '';

      var phraseIndex = 0;
      var typeNextCharacter = function() {
        if (!heroPreloadActive || heroPreloadCompleted || !heroPreloadCopyText) {
          return;
        }

        phraseIndex += 1;
        heroPreloadCopyText.textContent = phrase.slice(0, phraseIndex);

        if (phraseIndex < phrase.length) {
          var nextCharacter = phrase.charAt(phraseIndex);
          var typingDelay = nextCharacter === ' ' ? 18 : 28;
          heroPreloadPhraseTypingTimer = window.setTimeout(typeNextCharacter, typingDelay);
        } else {
          heroPreloadPhraseTypingTimer = null;
        }
      };

      typeNextCharacter();
    };

    var rotateHeroPreloadPhrase = function() {
      if (!heroPreloadActive || heroPreloadCompleted) {
        return;
      }

      var nextPhrase = getNextHeroPreloadPhrase();
      typeHeroPreloadPhrase(nextPhrase);

      var cadenceDelay = heroPreloadPhraseCadence[heroPreloadPhraseDelayIndex % heroPreloadPhraseCadence.length];
      heroPreloadPhraseDelayIndex += 1;
      heroPreloadPhraseCycleTimer = window.setTimeout(rotateHeroPreloadPhrase, cadenceDelay);
    };

    var clearHeroPrimaryBandwidthGateTimer = function() {
      if (heroPrimaryBandwidthGateTimer) {
        window.clearTimeout(heroPrimaryBandwidthGateTimer);
        heroPrimaryBandwidthGateTimer = null;
      }
    };

    var releaseHeroPrimaryBandwidthGate = function() {
      if (heroPrimaryBandwidthGateReleased) {
        return;
      }

      heroPrimaryBandwidthGateReleased = true;
      clearHeroPrimaryBandwidthGateTimer();
      queueManagedAutoplaySync();
    };

    var scheduleHeroPrimaryBandwidthGateTimer = function() {
      clearHeroPrimaryBandwidthGateTimer();
      heroPrimaryBandwidthGateTimer = window.setTimeout(function() {
        heroPrimaryBandwidthGateTimer = null;
        evaluateHeroPrimaryBandwidthGate(HERO_PRELOAD_BANDWIDTH_GATE_TIMEOUT_MS);
      }, HERO_PRELOAD_BANDWIDTH_GATE_TIMEOUT_MS + 60);
    };

    var isHeroPreloadPrimaryVideoFallbackReady = function(video) {
      if (!video) {
        return true;
      }

      if (video.dataset.nectrisVideoState === 'error') {
        return true;
      }

      return isManagedVideoPosterReady(video) &&
        (video.dataset.nectrisVideoReady === 'true' || video.readyState >= 2);
    };

    var getHeroPreloadAssetProgress = function(asset) {
      if (!asset) {
        return 1;
      }

      if (asset.tagName === 'VIDEO') {
        if (shouldFallbackManagedVideoToPoster(asset)) {
          return isManagedVideoPosterReady(asset) ? 1 : 0.16;
        }

        if (asset.dataset.nectrisVideoState === 'error') {
          return 1;
        }

        var posterUrl = asset.getAttribute('data-nectris-video-poster-url') || asset.getAttribute('poster');
        var posterImage = ensureManagedVideoPosterImage(asset);
        var posterReady = false;

        if (posterImage && posterUrl && posterImage.getAttribute('src') !== posterUrl) {
          posterImage.setAttribute('src', posterUrl);
        }

        if (posterImage && posterUrl) {
          posterReady = posterImage.complete && posterImage.naturalWidth > 0;
        }

        if (isManagedVideoFullyBuffered(asset)) {
          return 1;
        }

        var progress = 0.06;

        if (posterReady) {
          progress = 0.16;
        }

        if (asset.dataset.nectrisVideoSourcesAttached === 'true') {
          progress = Math.max(progress, 0.28);
        }

        if (asset.readyState >= 1 || asset.dataset.nectrisVideoState === 'metadata' || (isFinite(asset.duration) && asset.duration > 0)) {
          progress = Math.max(progress, 0.42);
        }

        if (asset.dataset.nectrisVideoReady === 'true' || asset.readyState >= 2) {
          progress = Math.max(progress, 0.56);

          if (isFinite(asset.duration) && asset.duration > 0) {
            var bufferedRatio = Math.max(0, Math.min(1, getManagedVideoBufferedEnd(asset) / asset.duration));
            progress = Math.max(progress, 0.56 + (bufferedRatio * 0.42));
          } else if (asset.readyState >= 3) {
            progress = Math.max(progress, 0.72);
          }
        }

        return Math.min(0.99, progress);
      }

      if (asset.tagName === 'IMG') {
        if (asset.complete && asset.naturalWidth > 0) {
          return 1;
        }

        if (asset.dataset.nectrisHeroPreloadError === 'true') {
          return 1;
        }

        return 0;
      }

      return 1;
    };

    var isHeroPreloadAssetSafe = function(asset, isPrimaryAsset, elapsedMs) {
      if (!asset) {
        return true;
      }

      if (asset.tagName === 'IMG') {
        return asset.complete && asset.naturalWidth > 0;
      }

      if (asset.dataset.nectrisVideoState === 'error') {
        return true;
      }

      if (shouldFallbackManagedVideoToPoster(asset)) {
        return isManagedVideoPosterReady(asset);
      }

      if (isPrimaryAsset) {
        if (isManagedVideoFullyBuffered(asset)) {
          return true;
        }

        if (isLikelyManagedVideoMobileEnvironment() && isManagedVideoPosterReady(asset)) {
          return true;
        }

        return elapsedMs >= HERO_PRELOAD_REVEAL_FALLBACK_TIMEOUT_MS && isHeroPreloadPrimaryVideoFallbackReady(asset);
      }

      if (asset.dataset.nectrisVideoReady === 'true' || asset.readyState >= 2) {
        return true;
      }

      return isManagedVideoPosterReady(asset);
    };

    var isHeroPreloadRevealSafe = function(elapsedMs) {
      if (!heroPreloadAssets.length) {
        return true;
      }

      return heroPreloadAssets.every(function(asset, index) {
        return isHeroPreloadAssetSafe(asset, index === 0, elapsedMs);
      });
    };

    var getHeroPreloadElapsedMs = function() {
      if (!heroPreloadStartedAt) {
        return 0;
      }

      return Math.max(0, Date.now() - heroPreloadStartedAt);
    };

    var isHeroPrimaryBandwidthGateReady = function(elapsedMs) {
      var primaryHeroVideo = getPrimaryHeroManagedVideo();

      if (!primaryHeroVideo) {
        return true;
      }

      if (primaryHeroVideo.dataset.nectrisVideoState === 'error') {
        return true;
      }

      if (shouldFallbackManagedVideoToPoster(primaryHeroVideo)) {
        return isManagedVideoPosterReady(primaryHeroVideo);
      }

      if (isManagedVideoFullyBuffered(primaryHeroVideo)) {
        return true;
      }

      return elapsedMs >= HERO_PRELOAD_BANDWIDTH_GATE_TIMEOUT_MS &&
        (isHeroPreloadPrimaryVideoFallbackReady(primaryHeroVideo) || isManagedVideoPosterReady(primaryHeroVideo));
    };

    var evaluateHeroPrimaryBandwidthGate = function(elapsedMs) {
      var resolvedElapsedMs = typeof elapsedMs === 'number' ? elapsedMs : getHeroPreloadElapsedMs();

      if (!heroPrimaryBandwidthGateReleased && isHeroPrimaryBandwidthGateReady(resolvedElapsedMs)) {
        releaseHeroPrimaryBandwidthGate();
        return true;
      }

      return heroPrimaryBandwidthGateReleased;
    };

    var hasHeroPreloadMetMinimumDuration = function(elapsedMs) {
      var resolvedElapsedMs = typeof elapsedMs === 'number' ? elapsedMs : getHeroPreloadElapsedMs();
      return resolvedElapsedMs >= HERO_PRELOAD_MIN_DURATION_MS;
    };

    var getHeroPreloadDisplayProgress = function(actualProgress, elapsedMs) {
      var normalizedActual = Math.max(0, Math.min(0.99, actualProgress || 0));

      if (hasHeroPreloadMetMinimumDuration(elapsedMs)) {
        return normalizedActual;
      }

      var timeRatio = Math.min(1, Math.max(0, elapsedMs) / HERO_PRELOAD_MIN_DURATION_MS);
      var displayFloor = timeRatio * HERO_PRELOAD_DISPLAY_PROGRESS_FLOOR;
      var displayCeiling = timeRatio * HERO_PRELOAD_DISPLAY_PROGRESS_CEILING;

      return Math.max(displayFloor, Math.min(normalizedActual, displayCeiling));
    };

    var setHeroPreloadProgress = function(progress) {
      var previousProgress = heroPreloadProgressValue;
      var normalized = Math.max(previousProgress, Math.min(1, progress || 0));
      heroPreloadProgressValue = normalized;
      var percent = Math.round(normalized * 100);

      if (heroPreloadPercent) {
        heroPreloadPercent.textContent = percent + '%';
      }

      if (heroPreloadBar) {
        heroPreloadBar.style.width = percent + '%';
      }
    };

    var completeHeroPreload = function(options) {
      var resolvedOptions = options || {};
      var hideImmediately = !!resolvedOptions.immediate;
      var preloadState = resolvedOptions.reason ? String(resolvedOptions.reason) : 'complete';
      var alreadyCompleted = heroPreloadCompleted && !heroPreloadActive;

      heroPreloadCompleted = true;
      heroPreloadActive = false;
      heroPreloadStartedAt = 0;
      setHeroPreloadProgress(1);
      clearHeroPreloadPhraseTimers();
      clearHeroPrimaryBandwidthGateTimer();
      releaseHeroPrimaryBandwidthGate();

      if (heroPreloadCopyText) {
        heroPreloadCopyText.textContent = 'Hero media ready.';
      }

      if (heroPreloadRafId) {
        window.cancelAnimationFrame(heroPreloadRafId);
        heroPreloadRafId = 0;
      }

      if (heroPreloadOverlay) {
        heroPreloadOverlay.classList.add('is-complete');
        heroPreloadOverlay.setAttribute('aria-busy', 'false');
        heroPreloadOverlay.setAttribute('data-nectris-preload-state', preloadState);

        if (hideImmediately) {
          heroPreloadOverlay.hidden = true;
        } else {
          window.setTimeout(function() {
            heroPreloadOverlay.hidden = true;
          }, 380);
        }
      }

      document.body.classList.remove('nectris-preload-locked');
      persistPrototypePreloadWarmMarker();

      if (alreadyCompleted) {
        return;
      }

      document.dispatchEvent(new CustomEvent('nectris:hero-preload-complete'));
      queueManagedAutoplaySync();
      syncDeferredImages();
      observeDeferredImages();
    };

    var finishHeroPreload = function() {
      if (!heroPreloadActive || heroPreloadCompleted) {
        return;
      }

      completeHeroPreload({
        immediate: false,
        reason: 'complete'
      });
    };

    var skipHeroPreload = function(reason) {
      var resolvedReason = reason || 'skip';

      markPrototypePreloadSkipState(resolvedReason);
      completeHeroPreload({
        immediate: true,
        reason: resolvedReason
      });
    };

    var updateHeroPreloadProgress = function() {
      if (!heroPreloadActive || heroPreloadCompleted) {
        return;
      }

      if (!heroPreloadAssets.length) {
        releaseHeroPrimaryBandwidthGate();
        finishHeroPreload();
        return;
      }

      var total = 0;

      Array.prototype.forEach.call(heroPreloadAssets, function(asset) {
        total += getHeroPreloadAssetProgress(asset);
      });

      var actualProgress = total / heroPreloadAssets.length;
      var elapsedMs = getHeroPreloadElapsedMs();
      var displayProgress = getHeroPreloadDisplayProgress(actualProgress, elapsedMs);
      var revealSafe = isHeroPreloadRevealSafe(elapsedMs);
      var minimumDurationMet = hasHeroPreloadMetMinimumDuration(elapsedMs);

      evaluateHeroPrimaryBandwidthGate(elapsedMs);
      setHeroPreloadProgress(displayProgress);

      if (!heroPreloadCompleted && minimumDurationMet && revealSafe) {
        finishHeroPreload();
        return;
      }
    };

    var tickHeroPreloadProgress = function() {
      if (!heroPreloadActive || heroPreloadCompleted) {
        heroPreloadRafId = 0;
        return;
      }

      updateHeroPreloadProgress();

      if (!heroPreloadCompleted) {
        heroPreloadRafId = window.requestAnimationFrame(tickHeroPreloadProgress);
      } else {
        heroPreloadRafId = 0;
      }
    };

    var startHeroPreload = function() {
      if (heroPreloadCompleted) {
        return;
      }

      if (!heroPreloadOverlay) {
        completeHeroPreload({
          immediate: true,
          reason: 'overlay-missing'
        });
        return;
      }

      heroPrimaryBandwidthGateReleased = false;
      clearHeroPrimaryBandwidthGateTimer();
      heroPreloadAssets = collectHeroPreloadAssets();

      if (!heroPreloadAssets.length) {
        completeHeroPreload({
          immediate: true,
          reason: 'empty'
        });
        return;
      }

      heroPreloadActive = true;
      heroPreloadProgressValue = 0;
      heroPreloadStartedAt = Date.now();
      heroPreloadPhraseDelayIndex = 0;
      heroPreloadPhraseCurrent = '';
      heroPreloadPhrasePool = [];
      document.body.classList.add('nectris-preload-locked');
      scheduleHeroPrimaryBandwidthGateTimer();

      Array.prototype.forEach.call(heroPreloadAssets, function(asset) {
        if (asset._nectrisHeroPreloadBound) {
          return;
        }

        asset._nectrisHeroPreloadBound = true;

        if (asset.tagName === 'IMG') {
          asset.addEventListener('load', updateHeroPreloadProgress, { passive: true });
          asset.addEventListener('error', function() {
            asset.dataset.nectrisHeroPreloadError = 'true';
            updateHeroPreloadProgress();
          }, { passive: true });
        }
      });

      updateHeroPreloadProgress();
      syncDeferredImages();
      observeDeferredImages();
      queueManagedAutoplaySync();

      rotateHeroPreloadPhrase();

      if (!heroPreloadCompleted && !heroPreloadRafId) {
        heroPreloadRafId = window.requestAnimationFrame(tickHeroPreloadProgress);
      }
    };

    Array.prototype.forEach.call(getAllManagedVideos(), function(video) {
      normalizeManagedAutoplayVideo(video);
      setManagedVideoPreloadMode(video, 'none');
      video.dataset.nectrisVideoSourcesAttached = 'false';
      video.dataset.nectrisVideoState = 'detached';

      video.addEventListener('loadstart', function() {
        video.dataset.nectrisVideoState = 'loading';
      }, { passive: true });

      video.addEventListener('progress', function() {
        if (activeManagedAutoplayStartupVideo === video && getManagedVideoRole(video) === 'hero') {
          scheduleManagedAutoplayStartupRelease(video);
        }

        evaluateHeroPrimaryBandwidthGate();
      }, { passive: true });

      ['loadeddata', 'canplay', 'canplaythrough', 'playing'].forEach(function(eventName) {
        video.addEventListener(eventName, function() {
          markManagedVideoReady(video);
          if (activeManagedAutoplayStartupVideo === video && getManagedVideoRole(video) === 'hero') {
            scheduleManagedAutoplayStartupRelease(video);
          }
          evaluateHeroPrimaryBandwidthGate();
          queueManagedAutoplaySync();
        }, { passive: true });
      });

      ['loadedmetadata'].forEach(function(eventName) {
        video.addEventListener(eventName, function() {
          if (video.readyState >= 2) {
            markManagedVideoReady(video);
          } else if ((video.getAttribute('preload') || 'none') === 'metadata') {
            video.dataset.nectrisVideoState = 'metadata';

            if (activeManagedVideoLoad === video) {
              activeManagedVideoLoad = null;
            }
          }

          evaluateHeroPrimaryBandwidthGate();
          queueManagedAutoplaySync();
        }, { passive: true });
      });

      video.addEventListener('suspend', function() {
        if ((video.getAttribute('preload') || 'none') === 'metadata' && !isManagedVideoReady(video)) {
          video.dataset.nectrisVideoState = 'metadata';

          if (activeManagedVideoLoad === video) {
            activeManagedVideoLoad = null;
          }
        }

        evaluateHeroPrimaryBandwidthGate();
        queueManagedAutoplaySync();
      }, { passive: true });

      ['abort', 'emptied'].forEach(function(eventName) {
        video.addEventListener(eventName, function() {
          var sourcesAttached = hasManagedVideoSources(video);
          var isExpectedManagedReload = sourcesAttached && video.dataset.nectrisVideoState === 'loading';

          if (isExpectedManagedReload) {
            return;
          }

          if (activeManagedVideoLoad === video) {
            activeManagedVideoLoad = null;
          }

          if (!sourcesAttached) {
            clearManagedVideoReadyState(video);
          }

          queueManagedAutoplaySync();
        }, { passive: true });
      });

      video.addEventListener('error', function() {
        if (activeManagedVideoLoad === video) {
          activeManagedVideoLoad = null;
        }

        releaseManagedAutoplayStartupVideo(video);
        video.dataset.nectrisVideoState = 'error';

        if (typeof refreshProofCardVideoUi === 'function') {
          refreshProofCardVideoUi(video);
        }

        evaluateHeroPrimaryBandwidthGate();
        queueManagedAutoplaySync();
      }, { passive: true });
    });

    if ('IntersectionObserver' in window) {
      managedAutoplayObserver = new IntersectionObserver(function() {
        queueManagedAutoplaySync();
      }, {
        threshold: [0, 0.01, 0.2, 0.5]
      });

      Array.prototype.forEach.call(getManagedAutoplayVideos(), function(video) {
        managedAutoplayObserver.observe(video);
      });
    }

    document.addEventListener('visibilitychange', queueManagedAutoplaySync);
    window.addEventListener('focus', queueManagedAutoplaySync);
    window.addEventListener('pageshow', queueManagedAutoplaySync);
    window.addEventListener('pageshow', function(event) {
      if (event && event.persisted) {
        skipHeroPreload('history');
      }
    });
    window.addEventListener('resize', queueManagedAutoplaySync);

    var offerInputs = section.querySelectorAll('[data-nectris-offer-input]');
    var selectedOfferTitle = section.querySelector('[data-nectris-selected-offer-title]');
    var selectedOfferNote = section.querySelector('[data-nectris-selected-offer-note]');

    var syncOfferCards = function(activeInput) {
      Array.prototype.forEach.call(section.querySelectorAll('[data-nectris-offer-card]'), function(card) {
        card.classList.remove('is-selected');
      });

      if (!activeInput) {
        return;
      }

      var activeCard = activeInput.closest('[data-nectris-offer-card]');

      if (activeCard) {
        activeCard.classList.add('is-selected');
      }

      if (selectedOfferTitle) {
        selectedOfferTitle.textContent = activeInput.getAttribute('data-offer-title') || '';
      }

      if (selectedOfferNote) {
        var note = activeInput.getAttribute('data-offer-note') || 'Fictional program only. The real nectar lives a little farther down the page.';
        selectedOfferNote.textContent = note;
      }
    };

    if (offerInputs.length) {
      Array.prototype.forEach.call(offerInputs, function(input) {
        input.addEventListener('change', function() {
          syncOfferCards(input);
        });
      });

      var checkedInput = section.querySelector('[data-nectris-offer-input]:checked') || offerInputs[0];

      if (checkedInput) {
        checkedInput.checked = true;
        syncOfferCards(checkedInput);
      }
    }

    var proofTicking = false;
    var activeProofId = null;
    var activeEditorialId = null;
    var heroTouchStartX = null;
    var heroTouchStartY = null;
    var heroTouchStartedAtEnd = false;

    var isHeroMediaLoopMode = function() {
      return !!heroMediaGrid && window.innerWidth <= 720 && heroMediaCards.length > 1 && heroMediaGrid.scrollWidth > heroMediaGrid.clientWidth + 4;
    };

    var getHeroMediaInset = function() {
      if (!heroMediaGrid) {
        return 0;
      }

      return parseFloat(window.getComputedStyle(heroMediaGrid).paddingLeft) || 0;
    };

    var getActiveHeroMediaIndex = function() {
      if (!heroMediaGrid || !heroMediaCards.length) {
        return 0;
      }

      var currentLeft = heroMediaGrid.scrollLeft;
      var nearestIndex = 0;
      var nearestDistance = Infinity;

      Array.prototype.forEach.call(heroMediaCards, function(card, index) {
        var distance = Math.abs(card.offsetLeft - currentLeft);

        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    };

    var isHeroMediaAtEnd = function() {
      if (!heroMediaGrid) {
        return false;
      }

      return heroMediaGrid.scrollLeft + heroMediaGrid.clientWidth >= heroMediaGrid.scrollWidth - 6;
    };

    var loopHeroMediaToStart = function() {
      if (!isHeroMediaLoopMode() || !heroMediaCards.length) {
        return;
      }

      heroMediaGrid.scrollTo({
        left: Math.max(heroMediaCards[0].offsetLeft - getHeroMediaInset(), 0),
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
    };

    if (heroMediaGrid && heroMediaCards.length > 1) {
      heroMediaGrid.addEventListener('touchstart', function(event) {
        if (!isHeroMediaLoopMode() || event.touches.length !== 1) {
          heroTouchStartX = null;
          heroTouchStartY = null;
          heroTouchStartedAtEnd = false;
          return;
        }

        heroTouchStartX = event.touches[0].clientX;
        heroTouchStartY = event.touches[0].clientY;
        heroTouchStartedAtEnd = isHeroMediaAtEnd() || getActiveHeroMediaIndex() >= heroMediaCards.length - 1;
      }, { passive: true });

      heroMediaGrid.addEventListener('touchend', function(event) {
        if (heroTouchStartX === null || heroTouchStartY === null || !event.changedTouches.length) {
          return;
        }

        var deltaX = event.changedTouches[0].clientX - heroTouchStartX;
        var deltaY = event.changedTouches[0].clientY - heroTouchStartY;

        heroTouchStartX = null;
        heroTouchStartY = null;

        if (!isHeroMediaLoopMode() || !heroTouchStartedAtEnd) {
          heroTouchStartedAtEnd = false;
          return;
        }

        heroTouchStartedAtEnd = false;

        if (deltaX >= -36 || Math.abs(deltaX) <= Math.abs(deltaY)) {
          return;
        }

        loopHeroMediaToStart();
      }, { passive: true });

      heroMediaGrid.addEventListener('touchcancel', function() {
        heroTouchStartX = null;
        heroTouchStartY = null;
        heroTouchStartedAtEnd = false;
      }, { passive: true });

      heroMediaGrid.addEventListener('scroll', queueManagedAutoplaySync, { passive: true });
    }

    if (followupFeature) {
      var followupMediaContainer = followupFeature.querySelector('.nectris-pdp__followup-feature-media');
      var followupMediaSlides = followupFeature.querySelectorAll('[data-nectris-followup-media-slide]');
      var followupOverlaySlides = followupFeature.querySelectorAll('[data-nectris-followup-overlay-slide]');
      var followupDots = followupFeature.querySelectorAll('[data-nectris-followup-dot]');
      var followupIntervalMs = parseInt(followupFeature.getAttribute('data-nectris-carousel-interval'), 10) || 0;
      var followupAutoplayEnabled = !prefersReducedMotion && followupFeature.getAttribute('data-nectris-carousel-autoplay') === 'true';
      var followupActiveIndex = 0;
      var followupAutoplayTimer = null;
      var followupAutoplayStopped = false;
      var followupTouchStartX = null;
      var followupTouchStartY = null;
      var followupZoomFrame = null;

      var clearFollowupAutoplay = function() {
        if (!followupAutoplayTimer) {
          return;
        }

        window.clearTimeout(followupAutoplayTimer);
        followupAutoplayTimer = null;
      };

      var getFollowupMediaShell = function(slide) {
        if (!slide) {
          return null;
        }

        return slide.querySelector('.nectris-pdp__followup-feature-image-shell');
      };

      var getFollowupSlideIntervalMs = function(index) {
        var slide = followupMediaSlides[index];

        if (!slide) {
          return followupIntervalMs;
        }

        var slideIntervalMs = parseInt(slide.getAttribute('data-nectris-carousel-interval'), 10) || 0;
        return slideIntervalMs >= 1000 ? slideIntervalMs : followupIntervalMs;
      };

      var freezeFollowupSlideZoom = function(slide) {
        var shell = getFollowupMediaShell(slide);

        if (!shell) {
          return;
        }

        var computedTransform = window.getComputedStyle(shell).transform;
        shell.style.transition = 'none';
        shell.style.transform = computedTransform && computedTransform !== 'none' ? computedTransform : 'scale(1)';
      };

      var resetFollowupSlideZoom = function(slide) {
        var shell = getFollowupMediaShell(slide);

        if (!shell) {
          return;
        }

        shell.style.transition = 'none';
        shell.style.transform = 'scale(1)';
      };

      var startFollowupSlideZoom = function(slide) {
        var shell = getFollowupMediaShell(slide);

        if (!shell) {
          return;
        }

        var targetScale = parseFloat(slide.getAttribute('data-nectris-followup-zoom-target'));
        var durationMs = parseInt(slide.getAttribute('data-nectris-followup-zoom-duration'), 10) || 0;

        if (!isFinite(targetScale) || targetScale <= 0) {
          targetScale = 1;
        }

        if (prefersReducedMotion || durationMs < 16 || Math.abs(targetScale - 1) < 0.001) {
          shell.style.transition = 'none';
          shell.style.transform = 'scale(1)';
          return;
        }

        shell.style.transition = 'none';
        shell.style.transform = 'scale(1)';
        shell.getBoundingClientRect();
        shell.style.transition = 'transform ' + durationMs + 'ms linear';
        shell.style.transform = 'scale(' + targetScale + ')';
      };

      var syncFollowupState = function(previousIndex) {
        if (followupZoomFrame) {
          window.cancelAnimationFrame(followupZoomFrame);
          followupZoomFrame = null;
        }

        Array.prototype.forEach.call(followupMediaSlides, function(slide, index) {
          var isActive = index === followupActiveIndex;
          var isPrevious = index === previousIndex;

          if (isActive) {
            resetFollowupSlideZoom(slide);
          } else if (isPrevious) {
            freezeFollowupSlideZoom(slide);
          } else {
            resetFollowupSlideZoom(slide);
          }

          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        Array.prototype.forEach.call(followupOverlaySlides, function(slide, index) {
          var isActive = index === followupActiveIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        Array.prototype.forEach.call(followupDots, function(dot, index) {
          var isActive = index === followupActiveIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        followupZoomFrame = window.requestAnimationFrame(function() {
          startFollowupSlideZoom(followupMediaSlides[followupActiveIndex]);
          followupZoomFrame = null;
        });

        queueManagedAutoplaySync();
      };

      var queueFollowupAutoplay = function() {
        clearFollowupAutoplay();

        var activeIntervalMs = getFollowupSlideIntervalMs(followupActiveIndex);

        if (!followupAutoplayEnabled || followupAutoplayStopped || followupMediaSlides.length < 2 || activeIntervalMs < 1000) {
          return;
        }

        followupAutoplayTimer = window.setTimeout(function() {
          setFollowupSlide(followupActiveIndex + 1, false);
        }, activeIntervalMs);
      };

      var setFollowupSlide = function(nextIndex, isManualInteraction) {
        if (!followupMediaSlides.length) {
          return;
        }

        if (isManualInteraction) {
          followupAutoplayStopped = true;
          clearFollowupAutoplay();
        }

        var previousIndex = followupActiveIndex;
        followupActiveIndex = (nextIndex + followupMediaSlides.length) % followupMediaSlides.length;
        syncFollowupState(previousIndex);
        queueFollowupAutoplay();
      };

      if (followupDots.length > 1) {
        Array.prototype.forEach.call(followupDots, function(dot, index) {
          dot.addEventListener('click', function() {
            setFollowupSlide(index, true);
          });
        });
      }

      if (followupMediaContainer && followupMediaSlides.length > 1) {
        followupMediaContainer.addEventListener('touchstart', function(event) {
          var touch = event.touches && event.touches[0];

          if (!touch) {
            return;
          }

          followupTouchStartX = touch.clientX;
          followupTouchStartY = touch.clientY;
        }, { passive: true });

        followupMediaContainer.addEventListener('touchend', function(event) {
          var touch = event.changedTouches && event.changedTouches[0];

          if (!touch || followupTouchStartX === null || followupTouchStartY === null) {
            followupTouchStartX = null;
            followupTouchStartY = null;
            return;
          }

          var deltaX = touch.clientX - followupTouchStartX;
          var deltaY = touch.clientY - followupTouchStartY;

          followupTouchStartX = null;
          followupTouchStartY = null;

          if (Math.abs(deltaX) < 36 || Math.abs(deltaX) <= Math.abs(deltaY)) {
            return;
          }

          setFollowupSlide(followupActiveIndex + (deltaX < 0 ? 1 : -1), true);
        }, { passive: true });

        followupMediaContainer.addEventListener('touchcancel', function() {
          followupTouchStartX = null;
          followupTouchStartY = null;
        }, { passive: true });
      }

      syncFollowupState(-1);
      queueFollowupAutoplay();
    }

    var getProofInset = function() {
      if (window.innerWidth > 720) {
        return 0;
      }

      var moduleInner = section.querySelector('.module-inner');

      if (!moduleInner) {
        return 0;
      }

      return parseFloat(window.getComputedStyle(moduleInner).paddingLeft) || 0;
    };

    var isProofMediaDelayMode = function() {
      return window.innerWidth <= 720;
    };

    var isProofSectionMediaActive = function() {
      if (!proofSection) {
        return true;
      }

      return isElementWithinLoadRange(proofSection, window.innerHeight * 0.8, window.innerHeight * 0.2);
    };

    var getProofCardForVideo = function(video) {
      if (!video) {
        return null;
      }

      return video.closest('[data-nectris-proof-card]');
    };

    var getProofCardActiveVideo = function(card) {
      if (!card) {
        return null;
      }

      return card.querySelector('.nectris-pdp__proof-card-media--active video');
    };

    var getProofCardVideoWrapper = function(video) {
      if (!video) {
        return null;
      }

      return video.closest('.nectris-pdp__proof-card-video');
    };

    var refreshProofCardVideoUi = function(video) {
      var wrapper = getProofCardVideoWrapper(video);

      if (!wrapper || !video) {
        return;
      }

      var isFallback = shouldFallbackManagedVideoToPoster(video);
      var isReady = video.dataset.nectrisProofVideoReady === 'true' || video.readyState >= 2;
      var isPlaying = isReady && !video.paused && !video.ended;

      wrapper.classList.toggle('is-video-fallback', isFallback);
      wrapper.classList.toggle('is-video-ready', !isFallback && isReady);
      wrapper.classList.toggle('is-video-playing', !isFallback && isPlaying);
    };

    var normalizeProofCardVideo = function(video) {
      if (!video) {
        return;
      }

      normalizeManagedAutoplayVideo(video);
      refreshProofCardVideoUi(video);
    };

    var clearProofCardVideoRetry = function(video) {
      if (!video || !video._nectrisProofRetryTimer) {
        return;
      }

      window.clearTimeout(video._nectrisProofRetryTimer);
      video._nectrisProofRetryTimer = null;
    };

    var scheduleProofCardVideoRetry = function(video) {
      if (!video || video.dataset.nectrisProofShouldPlay !== 'true') {
        return;
      }

      clearProofCardVideoRetry(video);

      video._nectrisProofRetryTimer = window.setTimeout(function() {
        video._nectrisProofRetryTimer = null;
        syncProofCardVideoState(video);
      }, 160);
    };

    var unlockProofCardVideo = function(video) {
      if (!video || video.dataset.nectrisProofUnlocked === 'true') {
        return;
      }

      if (shouldBlockProofVideoBeforeHeroPhaseCompletes()) {
        refreshProofCardVideoUi(video);
        return;
      }

      if (shouldFallbackManagedVideoToPoster(video)) {
        refreshProofCardVideoUi(video);
        return;
      }

      normalizeProofCardVideo(video);
      requestManagedVideoPriorityLoad(video, 1200, 3200, true);

      var unlockAttempt = video.play();

      if (!unlockAttempt || typeof unlockAttempt.then !== 'function') {
        return;
      }

      unlockAttempt.then(function() {
        video.dataset.nectrisProofUnlocked = 'true';
        video.pause();

        try {
          video.currentTime = 0;
        } catch (error) {}
      }).catch(function() {});
    };

    var primeProofCardVideo = function(video) {
      if (!video) {
        return;
      }

      if (shouldBlockProofVideoBeforeHeroPhaseCompletes()) {
        refreshProofCardVideoUi(video);
        return;
      }

      if (shouldFallbackManagedVideoToPoster(video)) {
        refreshProofCardVideoUi(video);
        return;
      }

      normalizeProofCardVideo(video);
      video.dataset.nectrisProofPrimed = 'true';
      requestManagedVideoPriorityLoad(video, 760, 2600, false);
      queueManagedAutoplaySync();
    };

    var pauseProofCardVideo = function(video, shouldResetTime) {
      if (!video) {
        return;
      }

      video.dataset.nectrisProofShouldPlay = 'false';
      clearProofCardVideoRetry(video);
      video.pause();

      if (!shouldResetTime) {
        refreshProofCardVideoUi(video);
        return;
      }

      try {
        video.currentTime = 0;
      } catch (error) {}

      refreshProofCardVideoUi(video);
    };

    var syncProofCardVideoState = function(video) {
      if (!video) {
        return;
      }

      var card = getProofCardForVideo(video);
      var shouldPlay = video.dataset.nectrisProofShouldPlay === 'true';

      if (!card || !card.classList.contains('is-active') || !shouldPlay) {
        pauseProofCardVideo(video, false);
        return;
      }

      if (shouldBlockProofVideoBeforeHeroPhaseCompletes()) {
        clearProofCardVideoRetry(video);
        refreshProofCardVideoUi(video);
        return;
      }

      if (shouldFallbackManagedVideoToPoster(video)) {
        clearProofCardVideoRetry(video);
        refreshProofCardVideoUi(video);
        return;
      }

      if (!isProofSectionMediaActive()) {
        clearProofCardVideoRetry(video);

        try {
          video.pause();
        } catch (error) {}

        refreshProofCardVideoUi(video);
        return;
      }

      normalizeProofCardVideo(video);
      setManagedVideoPreloadMode(video, 'auto');

      if (!isManagedVideoReady(video)) {
        requestManagedVideoPriorityLoad(video, 1400, 3600, true);
        refreshProofCardVideoUi(video);
        queueManagedAutoplaySync();
        scheduleProofCardVideoRetry(video);
        return;
      }

      var playAttempt = video.play();

      if (playAttempt && typeof playAttempt.catch === 'function') {
        playAttempt.catch(function() {
          refreshProofCardVideoUi(video);
          scheduleProofCardVideoRetry(video);
        });
      }
    };

    var playProofCardVideo = function(video) {
      if (!video) {
        return;
      }

      if (shouldFallbackManagedVideoToPoster(video)) {
        video.dataset.nectrisProofShouldPlay = 'true';
        clearProofCardVideoRetry(video);
        refreshProofCardVideoUi(video);
        return;
      }

      primeProofCardVideo(video);
      video.dataset.nectrisProofShouldPlay = 'true';
      clearProofCardVideoRetry(video);

      try {
        video.currentTime = 0;
      } catch (error) {}

      requestManagedVideoPriorityLoad(video, 1500, 3600, true);
      syncProofCardVideoState(video);
    };

    Array.prototype.forEach.call(proofCards, function(card) {
      var proofVideo = getProofCardActiveVideo(card);

      if (!proofVideo) {
        return;
      }

      normalizeProofCardVideo(proofVideo);
      proofVideo.dataset.nectrisProofShouldPlay = 'false';
      refreshProofCardVideoUi(proofVideo);

      ['loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough'].forEach(function(eventName) {
        proofVideo.addEventListener(eventName, function() {
          proofVideo.dataset.nectrisProofVideoReady = 'true';
          refreshProofCardVideoUi(proofVideo);
          syncProofCardVideoState(proofVideo);
        }, { passive: true });
      });

      proofVideo.addEventListener('playing', function() {
        proofVideo.dataset.nectrisProofVideoReady = 'true';
        refreshProofCardVideoUi(proofVideo);
        syncProofCardVideoState(proofVideo);
      }, { passive: true });

      proofVideo.addEventListener('pause', function() {
        refreshProofCardVideoUi(proofVideo);
      }, { passive: true });

      proofVideo.addEventListener('waiting', function() {
        refreshProofCardVideoUi(proofVideo);
      }, { passive: true });

      proofVideo.addEventListener('emptied', function() {
        delete proofVideo.dataset.nectrisProofVideoReady;
        refreshProofCardVideoUi(proofVideo);
      }, { passive: true });
    });

    Array.prototype.forEach.call(proofCards, function(card) {
      pauseProofCardVideo(getProofCardActiveVideo(card), true);
      card.classList.remove('is-proof-media-settled');
    });

    var setActiveProof = function(proofId, shouldScroll, isUserInitiated) {
      if (!proofId) {
        return;
      }

      if (proofId === activeProofId) {
        return;
      }

      var previousActiveProofId = activeProofId;
      var shouldDelayProofMedia = isProofMediaDelayMode() && previousActiveProofId !== null && previousActiveProofId !== proofId;

      activeProofId = proofId;

      Array.prototype.forEach.call(proofCards, function(card) {
        var isActive = card.getAttribute('data-nectris-proof-card') === proofId;
        var hasActiveMedia = !!card.querySelector('.nectris-pdp__proof-card-icon.has-active-media');
        var activeVideo = getProofCardActiveVideo(card);

        if (card._nectrisProofMediaTimer) {
          window.clearTimeout(card._nectrisProofMediaTimer);
          card._nectrisProofMediaTimer = null;
        }

        card.classList.toggle('is-active', isActive);

        if (!hasActiveMedia) {
          card.classList.remove('is-proof-media-settled');
          return;
        }

        if (!isActive) {
          card.classList.remove('is-proof-media-settled');
          pauseProofCardVideo(activeVideo, true);

          if (activeVideo && activeManagedVideoLoad === activeVideo && !isManagedVideoReady(activeVideo)) {
            abortManagedVideoLoad(activeVideo);
          }

          return;
        }

        if (activeVideo && !isUserInitiated && !isProofSectionMediaActive()) {
          if (previousActiveProofId === null) {
            card.classList.add('is-proof-media-settled');
          } else {
            card.classList.remove('is-proof-media-settled');
          }

          activeVideo.dataset.nectrisProofShouldPlay = 'true';
          clearProofCardVideoRetry(activeVideo);
          refreshProofCardVideoUi(activeVideo);

          return;
        }

        primeProofCardVideo(activeVideo);

        if (isUserInitiated) {
          boostManagedVideoPriority(activeVideo, 1400, 3600);
          unlockProofCardVideo(activeVideo);
        }

        if (!shouldDelayProofMedia || prefersReducedMotion) {
          card.classList.add('is-proof-media-settled');
          playProofCardVideo(activeVideo);
          return;
        }

        card.classList.remove('is-proof-media-settled');
        pauseProofCardVideo(activeVideo, true);
        card._nectrisProofMediaTimer = window.setTimeout(function() {
          if (card.classList.contains('is-active')) {
            playProofCardVideo(activeVideo);
            card.classList.add('is-proof-media-settled');
          }

          card._nectrisProofMediaTimer = null;
        }, 1000);
      });

      Array.prototype.forEach.call(proofNavItems, function(item) {
        var isActive = item.getAttribute('data-nectris-proof-nav') === proofId;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (!shouldScroll || !proofTrack) {
        return;
      }

      var targetCard = section.querySelector('[data-nectris-proof-card="' + proofId + '"]');

      if (targetCard && proofTrack.scrollWidth > proofTrack.clientWidth + 4) {
        proofTrack.scrollTo({
          left: Math.max(targetCard.offsetLeft - getProofInset(), 0),
          behavior: prefersReducedMotion ? 'auto' : 'smooth'
        });
      }
    };

    var syncProofFromScroll = function() {
      if (!proofTrack || !proofCards.length || proofTrack.scrollWidth <= proofTrack.clientWidth + 4) {
        return;
      }

      var currentLeft = proofTrack.scrollLeft;
      var nearestCard = null;
      var nearestDistance = Infinity;

      Array.prototype.forEach.call(proofCards, function(card) {
        var distance = Math.abs(card.offsetLeft - currentLeft);

        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestCard = card;
        }
      });

      if (!nearestCard) {
        return;
      }

      var proofId = nearestCard.getAttribute('data-nectris-proof-card');

      if (proofId !== activeProofId) {
        setActiveProof(proofId, false, false);
      }
    };

    var shiftActiveProof = function(direction) {
      if (!proofCards.length) {
        return;
      }

      var currentIndex = 0;

      Array.prototype.forEach.call(proofCards, function(card, index) {
        if (card.getAttribute('data-nectris-proof-card') === activeProofId) {
          currentIndex = index;
        }
      });

      var nextIndex = currentIndex + direction;

      if (nextIndex < 0) {
        nextIndex = proofCards.length - 1;
      }

      if (nextIndex >= proofCards.length) {
        nextIndex = 0;
      }

      setActiveProof(proofCards[nextIndex].getAttribute('data-nectris-proof-card'), true, true);
    };

    if (proofTrack && proofCards.length && proofNavItems.length) {
      Array.prototype.forEach.call(proofNavItems, function(item) {
        item.addEventListener('click', function() {
          setActiveProof(item.getAttribute('data-nectris-proof-nav'), true, true);
        });
      });

      Array.prototype.forEach.call(proofCards, function(card) {
        card.addEventListener('click', function() {
          setActiveProof(card.getAttribute('data-nectris-proof-card'), true, true);
        });
      });

      Array.prototype.forEach.call(proofArrowButtons, function(button) {
        button.addEventListener('click', function() {
          shiftActiveProof(button.getAttribute('data-nectris-proof-arrow') === 'prev' ? -1 : 1);
        });
      });

      proofTrack.addEventListener('scroll', function() {
        if (proofTicking) {
          return;
        }

        proofTicking = true;

        window.requestAnimationFrame(function() {
          syncProofFromScroll();
          proofTicking = false;
        });
      }, { passive: true });

      setActiveProof(proofCards[0].getAttribute('data-nectris-proof-card'), false, false);
      syncProofFromScroll();
      window.addEventListener('resize', syncProofFromScroll);
    }

    var syncAllProofCardVideos = function() {
      Array.prototype.forEach.call(proofCards, function(card) {
        syncProofCardVideoState(getProofCardActiveVideo(card));
      });
    };

    document.addEventListener('visibilitychange', syncAllProofCardVideos);
    window.addEventListener('focus', syncAllProofCardVideos);
    window.addEventListener('pageshow', syncAllProofCardVideos);

    var isEditorialAccordionMode = function() {
      return window.innerWidth <= 720;
    };

    var setActiveEditorial = function(editorialId) {
      if (!editorialItems.length) {
        return;
      }

      if (!editorialId || !section.querySelector('[data-nectris-editorial-item="' + editorialId + '"]')) {
        editorialId = editorialItems[0].getAttribute('data-nectris-editorial-item');
      }

      activeEditorialId = editorialId;

      Array.prototype.forEach.call(editorialItems, function(item) {
        var itemId = item.getAttribute('data-nectris-editorial-item');
        var trigger = item.querySelector('[data-nectris-editorial-trigger]');
        var panel = item.querySelector('[data-nectris-editorial-panel]');
        var isActive = !isEditorialAccordionMode() || itemId === activeEditorialId;

        item.classList.toggle('is-open', isActive);
        item.classList.toggle('is-collapsed', isEditorialAccordionMode() && !isActive);

        if (trigger) {
          trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }

        if (panel) {
          panel.hidden = isEditorialAccordionMode() ? !isActive : false;
        }

        Array.prototype.forEach.call(item.querySelectorAll('[data-nectris-editorial-carousel]'), function(carousel) {
          if (typeof carousel._nectrisRefreshCarousel === 'function') {
            carousel._nectrisRefreshCarousel();
          }

          if (typeof carousel._nectrisQueueAutoplay === 'function') {
            carousel._nectrisQueueAutoplay();
          }

          if (typeof carousel._nectrisWarmActiveSlide === 'function') {
            carousel._nectrisWarmActiveSlide();
          }
        });
      });
    };

    var syncEditorialAccordionState = function(preferredId) {
      if (!editorialItems.length) {
        return;
      }

      setActiveEditorial(preferredId || activeEditorialId || editorialItems[0].getAttribute('data-nectris-editorial-item'));
    };

    var syncPrototypeProofEditorialLinks = function() {
      var availableEditorialKeys = {};

      Array.prototype.forEach.call(editorialItems, function(item) {
        var featureKey = item.getAttribute('data-prototype-editorial-key');

        if (!featureKey) {
          return;
        }

        availableEditorialKeys[featureKey] = true;
      });

      Array.prototype.forEach.call(section.querySelectorAll('[data-prototype-proof-editorial-key]'), function(cta) {
        var proofKey = cta.getAttribute('data-prototype-proof-editorial-key');
        var hasMatch = !!(proofKey && availableEditorialKeys[proofKey]);

        cta.hidden = !hasMatch;
      });
    };

    var preserveEditorialTriggerPosition = function(trigger, startTop) {
      if (!trigger || !isEditorialAccordionMode() || typeof startTop !== 'number') {
        return;
      }

      window.requestAnimationFrame(function() {
        window.requestAnimationFrame(function() {
          var endTop = trigger.getBoundingClientRect().top;
          var delta = endTop - startTop;

          if (Math.abs(delta) < 1) {
            return;
          }

          window.scrollBy({
            top: delta,
            behavior: 'auto'
          });
        });
      });
    };

    if (editorialItems.length) {
      Array.prototype.forEach.call(editorialTriggers, function(trigger) {
        trigger.addEventListener('click', function() {
          var triggerTop = isEditorialAccordionMode() ? trigger.getBoundingClientRect().top : null;
          setActiveEditorial(trigger.getAttribute('data-nectris-editorial-trigger'));
          preserveEditorialTriggerPosition(trigger, triggerTop);
        });
      });

      syncEditorialAccordionState();
      window.addEventListener('resize', function() {
        syncEditorialAccordionState();
      });
    }

    syncPrototypeProofEditorialLinks();

    if (editorialCarousels.length) {
      Array.prototype.forEach.call(editorialCarousels, function(carousel) {
        var slides = carousel.querySelectorAll('[data-nectris-editorial-slide]');
        var dots = carousel.querySelectorAll('[data-nectris-editorial-dot]');
        var intervalMs = parseInt(carousel.getAttribute('data-nectris-carousel-interval'), 10) || 0;
        var autoplayEnabled = !prefersReducedMotion && carousel.getAttribute('data-nectris-carousel-autoplay') === 'true';
        var activeIndex = 0;
        var autoplayStopped = false;
        var autoplayTimer = null;
        var touchStartX = null;
        var touchStartY = null;

        var warmActiveCarouselVideo = function(isManualInteraction) {
          if (!isCarouselVisible()) {
            return;
          }

          var activeSlide = slides[activeIndex];
          var activeVideo = activeSlide ? activeSlide.querySelector('[data-nectris-managed-video]') : null;

          if (!activeVideo) {
            return;
          }

          requestManagedVideoPriorityLoad(activeVideo, isManualInteraction ? 980 : 420, isManualInteraction ? 3200 : 2200, !!isManualInteraction);
        };

        var isCarouselVisible = function() {
          var parentPanel = carousel.closest('[data-nectris-editorial-panel]');

          return !parentPanel || !parentPanel.hidden;
        };

        var clearCarouselAutoplay = function() {
          if (autoplayTimer) {
            window.clearTimeout(autoplayTimer);
            autoplayTimer = null;
          }
        };

        var syncCarouselState = function() {
          Array.prototype.forEach.call(slides, function(slide, index) {
            var isActive = index === activeIndex;

            slide.classList.toggle('is-active', isActive);
            slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

            Array.prototype.forEach.call(slide.querySelectorAll('video'), function(video) {
              normalizeManagedAutoplayVideo(video);

              if (isActive && isCarouselVisible()) {
                setManagedVideoPreloadMode(video, 'auto');
                playManagedAutoplayVideo(video);
              } else {
                pauseManagedAutoplayVideo(video);
              }
            });
          });

          Array.prototype.forEach.call(dots, function(dot, index) {
            var isActive = index === activeIndex;

            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-current', isActive ? 'true' : 'false');
          });

          warmActiveCarouselVideo(false);
          queueManagedAutoplaySync();
        };

        var queueCarouselAutoplay = function() {
          clearCarouselAutoplay();

          if (!autoplayEnabled || autoplayStopped || slides.length < 2 || intervalMs < 1000 || !isCarouselVisible()) {
            return;
          }

          autoplayTimer = window.setTimeout(function() {
            setCarouselSlide(activeIndex + 1, false);
          }, intervalMs);
        };

        var setCarouselSlide = function(nextIndex, isManualInteraction) {
          if (!slides.length) {
            return;
          }

          if (nextIndex < 0) {
            nextIndex = slides.length - 1;
          }

          if (nextIndex >= slides.length) {
            nextIndex = 0;
          }

          if (isManualInteraction) {
            autoplayStopped = true;
            clearCarouselAutoplay();
          }

          activeIndex = nextIndex;
          warmActiveCarouselVideo(isManualInteraction);
          syncCarouselState();
          queueCarouselAutoplay();
        };

        if (slides.length > 1) {
          Array.prototype.forEach.call(dots, function(dot, index) {
            dot.addEventListener('click', function() {
              setCarouselSlide(index, true);
            });
          });

          carousel.addEventListener('touchstart', function(event) {
            if (!isEditorialAccordionMode() || event.touches.length !== 1) {
              touchStartX = null;
              touchStartY = null;
              return;
            }

            touchStartX = event.touches[0].clientX;
            touchStartY = event.touches[0].clientY;
          }, { passive: true });

          carousel.addEventListener('touchend', function(event) {
            if (touchStartX === null || touchStartY === null || !event.changedTouches.length) {
              return;
            }

            var deltaX = event.changedTouches[0].clientX - touchStartX;
            var deltaY = event.changedTouches[0].clientY - touchStartY;

            touchStartX = null;
            touchStartY = null;

            if (Math.abs(deltaX) < 36 || Math.abs(deltaX) <= Math.abs(deltaY)) {
              return;
            }

            setCarouselSlide(activeIndex + (deltaX < 0 ? 1 : -1), true);
          }, { passive: true });

          carousel.addEventListener('touchcancel', function() {
            touchStartX = null;
            touchStartY = null;
          }, { passive: true });
        }

        carousel._nectrisRefreshCarousel = syncCarouselState;
        carousel._nectrisQueueAutoplay = queueCarouselAutoplay;
        carousel._nectrisWarmActiveSlide = function() {
          warmActiveCarouselVideo(false);
        };
        syncCarouselState();
        queueCarouselAutoplay();
      });
    }

    var activateManagedAutoplayVideosOnce = function() {
      if (managedVideoInteractionActivated) {
        return;
      }

      managedVideoInteractionActivated = true;

      Array.prototype.forEach.call(getManagedAutoplayVideos(), function(video) {
        if (isManagedAutoplayVideoVisible(video)) {
          requestManagedVideoPriorityLoad(video, 620, 2400, false);
        }
      });

      queueManagedAutoplaySync();
      section.removeEventListener('pointerdown', activateManagedAutoplayVideosOnce);
      section.removeEventListener('touchend', activateManagedAutoplayVideosOnce);
      section.removeEventListener('click', activateManagedAutoplayVideosOnce);
    };

    section.addEventListener('pointerdown', activateManagedAutoplayVideosOnce, { passive: true });
    section.addEventListener('touchend', activateManagedAutoplayVideosOnce, { passive: true });
    section.addEventListener('click', activateManagedAutoplayVideosOnce, { passive: true });
    detectManagedVideoConnectionProfile();
    var initialHeroPreloadSkipReason = getHeroPreloadSkipReason();

    if (initialHeroPreloadSkipReason) {
      skipHeroPreload(initialHeroPreloadSkipReason);
    } else {
      startHeroPreload();
    }

    var detailTriggers = section.querySelectorAll('[data-nectris-detail-trigger]');

    var closeAllDetails = function(exceptId) {
      Array.prototype.forEach.call(detailTriggers, function(trigger) {
        var triggerId = trigger.getAttribute('data-nectris-detail-trigger');
        var content = section.querySelector('[data-nectris-detail-content="' + triggerId + '"]');
        var shouldStayOpen = exceptId && triggerId === exceptId;

        if (!content || shouldStayOpen) {
          return;
        }

        trigger.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        content.hidden = true;
      });
    };

    Array.prototype.forEach.call(detailTriggers, function(trigger) {
      trigger.addEventListener('click', function() {
        var triggerId = trigger.getAttribute('data-nectris-detail-trigger');
        var content = section.querySelector('[data-nectris-detail-content="' + triggerId + '"]');
        var isOpen = trigger.classList.contains('is-open');

        if (!content) {
          return;
        }

        if (isOpen) {
          trigger.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          content.hidden = true;
          return;
        }

        closeAllDetails(triggerId);
        trigger.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        content.hidden = false;
      });
    });

    Array.prototype.forEach.call(section.querySelectorAll('.nectris-pdp__buybox-reference-accordion'), function(accordion) {
      var accordionDetails = accordion.querySelectorAll('.nectris-pdp__buybox-reference-detail');

      if (accordionDetails.length < 2) {
        return;
      }

      Array.prototype.forEach.call(accordionDetails, function(detail) {
        detail.addEventListener('toggle', function() {
          if (!detail.open) {
            return;
          }

          Array.prototype.forEach.call(accordionDetails, function(otherDetail) {
            if (otherDetail !== detail) {
              otherDetail.open = false;
            }
          });
        });
      });
    });

    var flashTarget = function(target) {
      if (!target) {
        return;
      }

      target.classList.add('is-highlighted');

      if (highlightTimer) {
        window.clearTimeout(highlightTimer);
      }

      highlightTimer = window.setTimeout(function() {
        target.classList.remove('is-highlighted');
      }, 2200);
    };

    Array.prototype.forEach.call(section.querySelectorAll('[data-nectris-scroll-trigger]'), function(link) {
      link.addEventListener('click', function(event) {
        var href = link.getAttribute('href');

        if (!href || href.charAt(0) !== '#') {
          return;
        }

        var target = document.querySelector(href);

        if (!target) {
          return;
        }

        if (target.hasAttribute('data-nectris-editorial-item')) {
          setActiveEditorial(target.getAttribute('data-nectris-editorial-item'));
        }

        event.preventDefault();
        target.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'start'
        });
        flashTarget(target);
      });
    });

    if (window.location.hash) {
      var hashTarget = document.querySelector(window.location.hash);

      if (hashTarget && section.contains(hashTarget)) {
        if (hashTarget.hasAttribute('data-nectris-editorial-item')) {
          setActiveEditorial(hashTarget.getAttribute('data-nectris-editorial-item'));
        }

        window.setTimeout(function() {
          flashTarget(hashTarget);
        }, 240);
      }
    }
  })();
